export const datosPersonalesStyles = {
  badge: {
    padding:'3px 7px',
    color:'#2f2f2f',
    textTransform:'capitalize'
  },
  
}
